/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TextBulletedHierarchyExcludeIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Text Bulleted Hierarchy Exclude',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M27 18.1a8.9 8.9 0 1 0 8.9 8.9 8.9 8.9 0 0 0-8.9-8.9ZM20 27a6.929 6.929 0 0 1 1.475-4.252l9.777 9.777A6.966 6.966 0 0 1 20 27Zm12.525 4.252-9.777-9.777a6.966 6.966 0 0 1 9.777 9.777Z"
    />
    <rect height="6" rx="2.8" ry="2.8" width="6" y="2" />
    <rect height="6" rx="2.8" ry="2.8" width="6" x="6" y="14" />
    <rect height="6" rx="2.8" ry="2.8" width="6" x="6" y="26" />
    <rect height="4" rx="1" ry="1" width="22" x="8" y="4" />
    <path
      d="M27 16H15a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3.515A10.975 10.975 0 0 1 27 16ZM16.05 28H15a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2.21a10.942 10.942 0 0 1-1.16-4Z"
    />
  </svg>`;
};
